import { z } from 'zod';

export const leadAgeRangeSchema = z.enum([
  'Moins de 30 ans',
  'De 31 à 40 ans',
  'De 41 à 50 ans',
  'De 51 à 60 ans',
  'De 61 à 70 ans',
  'Plus de 70 ans',
]);

export const leadCompanySchema = z
  .string()
  .trim()
  .min(1, "Le nom de l'entreprise est requis")
  .max(150, "Le nom de l'entreprise doit contenir au maximum 150 caractères")
  .regex(/^[\p{L}\p{N} ]+$/u, "Le nom de l'entreprise ne doit pas contenir de caractères spéciaux");

export const leadSchema = z.object({
  id: z.string().uuid().optional(),
  email: z.string().email('Email invalide').min(1, "L'email est requis"),
  firstName: z.string().min(1, 'Le prénom est requis'),
  lastName: z.string().min(1, 'Le nom est requis'),
  phone: z.string().optional().nullable(),
  ageRange: leadAgeRangeSchema.optional().nullable(),
  company: leadCompanySchema.optional().nullable(),
  acceptedTerms: z.boolean().optional(),
  regionId: z.string().uuid("ID de région invalide"),
  createdAt: z.date().optional(),
});

export type Lead = z.infer<typeof leadSchema>;

export const createLeadSchema = leadSchema.omit({ 
  id: true, 
  createdAt: true 
}).extend({
  acceptedTerms: z.boolean().refine((value) => value === true, {
    message: 'Les conditions générales doivent être acceptées.',
  }),
  playToken: z.string().min(1, "Token de jeu requis")
});
